class Amplitude {
    postLogEvent(eventName, properties) {
        if (process.env.VUE_APP_ENV === 'demo') {
            return;
        }

        amplitude.getInstance().logEvent(eventName, properties);
    }
}
export default new Amplitude();
